import { SelectItem } from '@mantine/core';

export const cardTypesData: SelectItem[] = [
  { label: 'MASTERCARD', value: '1' },
  { label: 'VISA', value: '2' },
  { label: 'AMERICAN EXPRESS', value: '3' },
  { label: 'DINERS', value: '4' },
  { label: 'DISCOVER', value: '5' },
  { label: 'JCB', value: '6' },
  { label: 'CHINABANK', value: '7' },
  { label: 'CITIBANK', value: '8' },
  { label: 'BARCLAY CARD', value: '9' },
  { label: 'DEBIT', value: '10' },
  { label: 'CHEQUE', value: '11' },
  { label: 'CASH', value: '12' },
  { label: 'EBT', value: '13' },
  { label: 'OFFLINE', value: '14' },
  { label: 'PAYMAYA QR', value: '15' },
  { label: 'GCASH QR', value: '16' },
  { label: 'PAYMAYA QR PH', value: '17' },
  { label: 'PAYMAYA WALLET LINK', value: '18' },
  { label: 'AUB', value: '19' },
];
